function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "none",
  d: "M0 0h32v32H0z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.754 22.552a.3.3 0 00.261.448h15.97a.3.3 0 00.262-.448L16.262 8.461a.3.3 0 00-.523 0L7.754 22.552zM17 21h-2v-2h2v2zm0-3h-2v-4h2v4z",
  fill: "#FC4F52"
});

var SvgIconStudentStatusWarnning = function SvgIconStudentStatusWarnning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none"
  }, props), _ref, _ref2);
};

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHJlY3Qgd2lkdGg9IjMyIiBoZWlnaHQ9IjMyIiBmaWxsPSJibGFjayIgZmlsbC1vcGFjaXR5PSIwIi8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNNy43NTQyOCAyMi41NTIxQzcuNjQwOTUgMjIuNzUyMSA3Ljc4NTQyIDIzIDguMDE1MjggMjNIMjMuOTg1NkMyNC4yMTU1IDIzIDI0LjM2IDIyLjc1MjEgMjQuMjQ2NyAyMi41NTIxTDE2LjI2MTUgOC40NjA2QzE2LjE0NjYgOC4yNTc4IDE1Ljg1NDQgOC4yNTc4IDE1LjczOTUgOC40NjA2TDcuNzU0MjggMjIuNTUyMVpNMTcuMDAwNSAyMUgxNS4wMDA1VjE5SDE3LjAwMDVWMjFaTTE3LjAwMDUgMThIMTUuMDAwNVYxNEgxNy4wMDA1VjE4WiIgZmlsbD0iI0ZDNEY1MiIvPgo8L3N2Zz4K";
export { SvgIconStudentStatusWarnning as ReactComponent };